var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeldoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62781 18.5013C4.61206 18.52 4.62835 18.5452 4.64441 18.5452H20.0165C20.1833 18.5454 20.2428 18.7964 20.0975 18.8968L15.1307 22.2893H15.1366C14.9804 22.396 14.8189 22.1702 14.9266 22.0071L15.8309 20.6966C15.917 20.5713 15.8423 20.3894 15.7079 20.3889H2.70594C2.44202 20.3889 2.18292 20.257 2.03211 20.0061C1.80078 19.6298 1.84934 19.1282 2.11316 18.8147L12.2929 6.95926H14.5331L4.62781 18.5013ZM8.86316 1.72196C9.01919 1.61585 9.18045 1.84122 9.07313 2.00418L8.16785 3.31571C8.08205 3.44112 8.15739 3.62228 8.29188 3.62235H21.2938C21.5577 3.62235 21.8168 3.75426 21.9677 4.00516C22.1992 4.3815 22.1505 4.88394 21.8866 5.19754L11.7069 17.052H9.4657L19.3768 5.51688C19.3768 5.51406 19.3758 5.47293 19.3602 5.47293H3.98328C3.81642 5.47293 3.75716 5.22283 3.90223 5.12235L8.86316 1.72196Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeldoc);
export default __webpack_public_path__ + "static/media/zeldoc.b23f8d27cdc2f2ed0c1da31fe54d95a4.svg";
export { ForwardRef as ReactComponent };